// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "close__icon-oM1X1";
export { _1 as "__esModule", _2 as "close__icon" }
export default { "__esModule": _1, "close__icon": _2 }
